<template>
  <div>
    <FormBox title="证件上传" :width="600">
      <el-row :gutter="20" style="width: 100%">
        <el-col :span="12">
          <ImageUpload
              v-model="legalIdCardFront"
              class="image-upload"
              imgType="FRONT"
              label="负责人身份证正面"
              style="height: 200px"
          />
        </el-col>
        <el-col :span="12">
          <ImageUpload
              v-model="legalIdCardBack"
              class="image-upload"
              imgType="BACK"
              label="负责人身份证背面"
              style="height: 200px"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="width: 100%; margin-top: 20px">
        <el-col :span="24">
          <ImageUpload
              v-model="organizationRegImg"
              class="image-upload"
              imgType="LICENSE"
              label="公证机构执业证"
              style="height: 300px"
          />
        </el-col>
        <!--        <el-col :span="12">-->
        <!--          <ImageUpload-->
        <!--            v-model="signImg"-->
        <!--            class="image-upload"-->
        <!--            imgType="LICENSE"-->
        <!--            label="公证处公章（选填）"-->
        <!--            style="height: 200px"-->
        <!--          />-->
        <!--        </el-col>-->
      </el-row>

      <el-button
          :loading="loading"
          type="primary"
          class="login-btn"
          @click="submit"
      >提交</el-button
      >
    </FormBox>
  </div>
</template>

<script>
import FormBox from "./components/form-box";
import ImageUpload from "./components/image-upload";


import Notice from '@/utils/notice.js';
export default {
  components: {
    FormBox,
    ImageUpload,
  },
  data() {
    return {
      legalIdCardFront: "", // 负责人身份证正面
      legalIdCardBack: "", // 负责人身份证背面
      organizationRegImg: "", // 公证机构执业证书
      // signImg: "", // 印章图片
      loading: false,
    };
  },
  mounted() {
    console.log(this.$store.state.opening.gzcInfo)
  },
  // 在需要监听数据的组件中添加
  watch: {
    '$store.state.opening.gzcCertificates': {
      deep: true,
      handler(newVal) {
        console.log('gzCertificates 变化:', newVal);
      }
    }
  },
  methods: {
    submit() {
      if (this.legalIdCardFront === '') {
        this.$message.error('请选择负责人身份证正面');
        return;
      }
      if (this.legalIdCardBack === '') {
        this.$message.error('请选择负责人身份证背面');
        return;
      }
      if (this.organizationRegImg === '') {
        this.$message.error('请选择公证机构执业证');
        return;
      }
      if (!this.legalIdCardFront || !this.legalIdCardBack || !this.organizationRegImg) {
        this.$message.error('请上传所有必要证件');
        return;
      }
      console.log('准备提交');
      this.$store.commit('opening/updateGzcCertificates', {
        legalIdCardFront: this.legalIdCardFront,
        legalIdCardBack: this.legalIdCardBack,
        organizationRegImg: this.organizationRegImg
        // signImg: this.signImg || ''
      });
      this.$router.push('/opening/infoInput')
    },
  },
};
</script>

<style lang='less' scoped>
.image-upload {
  margin-bottom: 10px;
  &:nth-last-child(1) {
    margin-bottom: 0;
  }
}
.login-btn {
  width: 200px;
  height: 40px;
  background: #1f8df2;
  border-radius: 20px;
  border: none;
  margin-top: 20px;
}
</style>